import { PAPER_SET, CATALOG_BOOK, CATALOG_CHAPTER } from '@constants/index';

const typeIconMap = {
  [CATALOG_BOOK]:
    'https://static.uacdn.net/catalogue/default/icon/book_default.jpg',
  [PAPER_SET]:
    'https://static.uacdn.net/catalogue/default/icon/paperset_default.jpg',
  [CATALOG_CHAPTER]:
    'https://static.uacdn.net/catalogue/default/icon/chapter_default.jpg'
};

function solutionCatalogModel(solutionCatalog) {
  return {
    uid: solutionCatalog.uid,
    id: solutionCatalog.id,
    title: solutionCatalog.title,
    slug: solutionCatalog.slug,
    rank: solutionCatalog.rank,
    type: solutionCatalog.type, // book || papers
    secText1: solutionCatalog.sub_titles?.[0]?.text,
    secText2: solutionCatalog.sub_titles?.[1]?.text,
    ctlgIcon:
      solutionCatalog.icon ||
      typeIconMap[solutionCatalog.type] ||
      'https://static.uacdn.net/catalogue/default/icon/paper_default.jpg',
    color: solutionCatalog.color
  };
}

function getEntityData(data) {
  return solutionCatalogModel(data);
}

const solutionCatalog = {
  SolutionCatalog: solutionCatalogModel,
  getEntityData
};

export default solutionCatalog;
